import React from 'react'
import { Popup, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import map from 'lodash/map'
import capitalize from 'lodash/capitalize'

const packageSizes = ['all', 'small', 'medium', 'large']

export default class PackageSizeButton extends React.PureComponent {
  state = { visible: false }

  onConfirmPackageClick = async packageSize => {
    const { order, setLoading } = this.props

    try {
      this.setState({ visible: false })

      setLoading('confirmingPackage', true)

      const params = {
        packageSize,
        orderUid: order.key,
        branchUid: order.restaurant.branch.key,
      }

      const functions = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('orderAction')

      await functions({ actionType: 'confirm', ...params })
    } catch (error) {
      setLoading('confirmingPackage', false)
      alert(error.message || error)
    }
  }

  onConfirmDriverClick = () => {
    const { showModalPackage } = this.props

    showModalPackage()
  }

  onPopupAction = () => {
    const { visible } = this.state

    this.setState({ visible: !visible })
  }

  renderOptions = () => {
    return map(packageSizes, size => (
      <div style={{ marginBottom: 3 }} key={size}>
        <Button size="tiny" fluid onClick={() => this.onConfirmPackageClick(size)}>
          {capitalize(size)}
        </Button>
      </div>
    ))
  }

  renderPopupTrigger = () => {
    const { order, confirmingPackage, confirmingDriver, readOnly } = this.props

    return (
      <Button
        size="mini"
        loading={confirmingPackage}
        style={{ margin: 0, marginTop: 5, width: 150 }}
        disabled={confirmingPackage || confirmingDriver || order.driver_pending_order || readOnly}
      >
        Confirm With Package
      </Button>
    )
  }

  render() {
    const { visible } = this.state
    const { order, confirmingDriver, confirmingPackage, readOnly, readyToPickUp } = this.props

    return (
      <React.Fragment>
        {!readyToPickUp && (order.order_type !== "pick-up") && (
          <div>
            <Button
              size="mini"
              color="black"
              loading={confirmingDriver}
              onClick={this.onConfirmDriverClick}
              style={{ margin: 0, marginTop: 5, width: 150 }}
              disabled={confirmingDriver || confirmingPackage || order.driver_pending_order || readOnly}
            >
              Confirm With Driver
            </Button>
          </div>
        )}

        <div>
          <Popup
            wide
            on="click"
            hideOnScroll
            open={visible}
            position="bottom center"
            onOpen={this.onPopupAction}
            onClose={this.onPopupAction}
            trigger={this.renderPopupTrigger()}
          >
            {this.renderOptions()}
          </Popup>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/Confirm.js